import React from 'react';
import PropTypes from 'prop-types';

const Abbr = ({ title, children, breakpoint }) => (
    <abbr
        className={`cmn-abbr cmn-abbr_from-${breakpoint}`}
        title={title}
    >
        <span className="cmn-abbr__inner">
            {children || title.charAt(0)}
        </span>
    </abbr>
);

Abbr.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    breakpoint: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']).isRequired
};

export default Abbr;



// WEBPACK FOOTER //
// ./~/rp-react-common/Abbr/Abbr.jsx